import React, {useContext, useEffect, useState} from "react";
import {Notification} from "../../models/notification_model";
import {getNotifications, updateNotification} from "../../api/notification_api";
import {useNavigate} from "react-router-dom";
import {useAuthInfo, WithLoggedInAuthInfoProps, withRequiredAuthInfo} from "@propelauth/react";
import BaseLoadingSpinner from "../ui/baseLoadingSpinner";

type NotificationHomeProps = WithLoggedInAuthInfoProps & {
    isHome?: boolean;
};

const NotificationHome = ({isHome=false}: NotificationHomeProps) => {
    const [notifications, setNotifications] = useState<Notification[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false)
    const navigate = useNavigate();
    const { accessToken } = useAuthInfo();
    console.log(notifications)
    useEffect(() => {
        const fetchNotifications = async () => {

            try {
                const data = await getNotifications(accessToken!);
                const limitedData = isHome ? data.slice(0, 3) : data;
                setNotifications(limitedData);
            } catch (error) {
                setError(true)
                console.error("Error fetching notifications", error);
            } finally {
                setLoading(false);
            }
        };

        fetchNotifications();
    }, [accessToken]);

    // const handleGoTo = (url: string) => {
    //     navigate(url);
    // };
    const handleGoTo = async (url: string, index: number, is_read: boolean, notificationId:string) => {
        navigate(`/${url}`);
        
        if (!is_read) {
            const notificationToUpdate = notifications[index];
            if (notificationToUpdate) {
                const updatedNotification = { ...notificationToUpdate, is_read: true };
                try {
                    await updateNotification(accessToken as string, notificationId, updatedNotification)
                    setNotifications((prevNotifications) =>
                        prevNotifications.map((notification, i) =>
                            i === index ? updatedNotification : notification
                        )
                    );
                }catch(err) {
                    console.log(err)
                }
            }
        }

    };

    if (loading) {
        return <div className="text-center"><BaseLoadingSpinner/></div>;
    }

    if (error) {
        return <div>Failed to load notification. Please, try later</div>
    }

    return (
        <div className="bg-white p-6 rounded-lg shadow-md w-full">
            <h2 className="text-xl font-bold mb-4">Latest Notifications</h2>
            {notifications.length === 0 ? (
                <p className="text-gray-500">No new notifications</p>
            ) : (
                <div className="space-y-4">
                    {notifications.map((notification, index) => (
                        <div
                            key={notification._id}
                            className={`p-4 mb-2 rounded-lg border-b border-gray-100
                                ${notification.is_read ? 'bg-gray-100 text-gray-400 opacity-50' : 'bg-gray-100 text-gray-800 opacity-100'}
                            `}
                        >
                            <div className="flex justify-between items-start">
                                <div>
                                    <p className="text-sm font-semibold text-gray-700">
                                        {notification.notification[0].tool}: {notification.notification[0].message}
                                    </p>
                                    <small className="text-xs text-gray-400">
                                        {new Date(
                                            notification.notification[0].created_at
                                        ).toLocaleString()}
                                    </small>
                                </div>
                                <button
                                    className="text-blue-500 text-sm hover:underline"
                                    onClick={() =>
                                        handleGoTo(
                                            notification.notification[0].url,
                                            index,
                                            notification.is_read,
                                            notification.notification_id                                       )
                                    }
                                >
                                    Go to
                                </button>
                            </div>
                            <p className="text-gray-600 mt-2">
                                {notification.notification[0].tool}
                            </p>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default withRequiredAuthInfo(NotificationHome);
